var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHashtag = function SvgHashtag(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.833 14.667.781-4.167m0 0 .938-5m-.938 5h5.834m-5.834 0H.917m4.635-5 .781-4.167M5.552 5.5h5.833m-5.833 0H1.75m7.916 9.167.782-4.167m0 0 .937-5m-.937 5h3.802m-2.865-5 .781-4.167m-.78 4.167h3.697"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHashtag);
export default ForwardRef;